import React from 'react';
import { useContext } from 'react';
import { AppContext } from './AppContext';
import { ErrorBoundary } from './ErrorBoundary';
export var parseTextConfig = function (textConfig, parse) {
    return textConfig.replace(/\{\{(.*?)\}\}/g, function (match, key) { return parse[key]; });
};
export var createTFunc = function (textConfig, rootT) {
    return function (textName, parse) {
        var key = textName;
        var text = textConfig[key] || '';
        if (parse) {
            text = parseTextConfig(text, parse);
        }
        if (!text && rootT) {
            try {
                return rootT(textName, parse) || '';
            }
            catch (_a) { }
        }
        return text;
    };
};
var ReactFeatureContext = React.createContext({
    t: function () { return ''; },
    getProxy: function () { return undefined; }
});
export var useFeatureContext = function () {
    return useContext(ReactFeatureContext);
};
export var WithFeatureContext = function (component, textsConfig, proxiesConfig) {
    return function (props) {
        var _a = useFeatureContext(), t = _a.t, getProxy = _a.getProxy;
        var appContext = useContext(AppContext);
        return React.createElement(ErrorBoundary, null, React.createElement(ReactFeatureContext.Provider, {
            value: {
                t: createTFunc(textsConfig, t),
                getProxy: function (proxyName) {
                    var proxy = proxiesConfig ? proxiesConfig[proxyName] : null;
                    if (!proxy) {
                        try {
                            proxy = getProxy(proxyName);
                        }
                        catch (_a) { }
                    }
                    if (!proxy) {
                        throw new Error("WithFeatureContext error: proxy \"" + proxyName + "\" not provided");
                    }
                    if (proxy && appContext && typeof proxy.setContext === 'function') {
                        proxy.setContext(appContext.getApiRequest());
                    }
                    return proxy;
                }
            }
        }, React.createElement(component, props)));
    };
};
//# sourceMappingURL=FeatureContext.js.map